import _ from 'lodash';

const YesNoBooleanField = ({ record, source }) => {
    return _.get(record, source) ? 'ON' : 'OFF';
};

export default YesNoBooleanField;
